export const SITE = {
  name: "Shriya Redkar Interiors",
  short: "Shriya Redkar",
  tagline: "Designed in 3D. Delivered in reality.",
  domain: "interiorfuse.com",
  url: "https://interiorfuse.com",
  whatsappNumber: "919769563656",
  phoneDisplay: "+91 97695 63656",
  phoneHref: "+919769563656",
  instagramHandle: "@shriyaredkarinteriors",
  instagramUrl: "https://instagram.com/shriyaredkarinteriors",
};

export const waLink = (msg: string) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(msg)}`;

export const waDefaultLink = () =>
  waLink("Hi Shriya! I'd like to discuss a turnkey interior project.");

export interface City {
  slug: string;
  name: string;
  blurb: string;
  areas: string;
}

export const CITIES: City[] = [
  {
    slug: "mumbai",
    name: "Mumbai",
    blurb:
      "Sea-facing apartments, duplexes and builder flats from Worli to Powai — engineered for tight Mumbai timelines and even tighter walls.",
    areas: "Malabar Hill · Worli · Bandra · Juhu · Powai · South Bombay",
  },
  {
    slug: "navi-mumbai",
    name: "Navi Mumbai",
    blurb:
      "The studio's home ground. Spacious 3BHKs, villas and offices across Palm Beach Road and the nodes — where our execution teams are strongest.",
    areas: "Palm Beach Road · Seawoods · Kharghar · Vashi · Belapur",
  },
  {
    slug: "thane",
    name: "Thane",
    blurb:
      "Hiranandani Estate, Ghodbunder Road and the lake-side towers — compact 2 and 3 BHKs where every wall has to earn its place, delivered with the same render-to-reality proof.",
    areas: "Hiranandani Estate · Ghodbunder Road · Majiwada · Kolshet",
  },
  {
    slug: "pune",
    name: "Pune",
    blurb:
      "Penthouses and full-home turnkey for Pune's new premium addresses — monsoon-proofed, marble-argued and delivered on schedule.",
    areas: "Koregaon Park · Kalyani Nagar · Baner · Viman Nagar",
  },
  {
    slug: "delhi",
    name: "Delhi",
    blurb:
      "Colonial-era apartments and modern homes — classic panelling, brass and restraint for the capital's quiet luxury.",
    areas: "Golf Links · Chanakyapuri · Greater Kailash · Defence Colony",
  },
  {
    slug: "lucknow",
    name: "Lucknow",
    blurb:
      "Villas that carry Awadhi craft into modern living — jaali, lime plaster and hand-cut teak, built with karigars we've worked with for years.",
    areas: "Gomti Nagar · Sushant Golf City · Hazratganj",
  },
  {
    slug: "rishikesh",
    name: "Rishikesh",
    blurb:
      "Riverside villas and second homes in the foothills — serene, light-washed bedroom suites and living spaces built to hill-station weather, delivered with the same render-to-reality proof.",
    areas: "Tapovan · Laxman Jhula · Shivpuri · Dehradun Road",
  },
];

export const BUDGET_BANDS = ["₹10L–25L", "₹25L–50L", "₹50L+"] as const;
export const PROPERTY_TYPES = [
  "Full-Home Turnkey",
  "Duplex / Penthouse",
  "Villa / Bungalow",
  "Commercial / Office",
] as const;
export const TIMELINES = [
  "Ready to start (0–3 months)",
  "3–6 months",
  "6–12 months",
  "Just exploring",
] as const;

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Consultation & Space Mapping",
    desc: "We measure every wall and listen to how you actually live. Site realities — beams, shafts, old-building quirks — are mapped before a single line is drawn.",
  },
  {
    n: "02",
    title: "Photorealistic 3D, Real Materials",
    desc: "Your renders are built with the actual stone, veneer and fabric samples — not approximations. You approve exactly what you'll touch.",
  },
  {
    n: "03",
    title: "Fixed BOQ, Zero Hidden Costs",
    desc: "The bill of quantities is locked to the approved 3D. If it isn't on the render, it isn't on your invoice.",
  },
  {
    n: "04",
    title: "Turnkey Execution, 6 Squads",
    desc: "Civil, electrical, carpentry, painting, modular and styling teams run on one schedule, one supervisor, one accountable studio.",
  },
  {
    n: "05",
    title: "Audit & White-Glove Handover",
    desc: "A room-by-room audit against the approved render. You walk into a snag-free home with a warranty file and a studio that answers the phone.",
  },
];

export const cityBySlug = (slug?: string) => CITIES.find((c) => c.slug === slug);

export const phoneDisplay = SITE.phoneDisplay;
